<template>
	<div class="formTabWrapper">
		<div class="formTabTableWrap">
			<div class="formTabTableWrap_top">
				<div class="formTabTableWrap_top-title">Logs</div>
				<div class="formTabTableWrap_top-add">

				</div>
			</div>
			<div class="formTabTableWrap_body">
				<main-table
						padding="0 0 10px"
						flag="logs"
						:headers="getHeaders"
						:listItems="logs"
						:filtersList="logsFilter"
						:is-hide-header="false"
						:items-per-page-amount="10"
						:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
						@updateSearch="onFilter"
						@updateRefreshFilters="onFilter"
						@updateChangeSort="onFilter"
				></main-table>
			</div>
		</div>
	</div>

</template>

<script>
// vuex
import { mapActions, mapGetters } from "vuex";
import {
	logsHeader
} from "@/components/Accounting/CustomerInvoices/CustomerInvoicesCreate/defaultHeaders";

export default {
	name: "SixthTab",
	computed: {
		...mapGetters([
			"logs",
			"logsFilter",
		]),
		getHeaders() {
			return logsHeader;
		}
	},
	methods: {
		...mapActions([ 'onDriversFilterLogs' ]),

		async onFilter(info) {
			await this.onDriversFilterLogs(info.filterModList);
		},
	},
};
</script>

<style lang="scss">
@import "@/assets/style/components/formTab/formTabTableWrap";
</style>
